module.exports = __webpack_public_path__ + "static/media/likha.9aa921d5.png";